import { createAction, props } from '@ngrx/store';

import { Alert } from '../../domain/models';

export const NotfAlertLoadRequested = createAction(
    '[NOTF-ALERT] Load Alert Requested'
);

export const NotfAlertLoadSucceeded = createAction(
    '[NOTF-ALERT] Load Alert Succeeded',
    props<{ alerts: Alert[] }>()
);

export const NotfCreateAlertRequested = createAction(
    '[NOTF-ALERT] Create Alert Requested',
    props<Alert>()
);

export const NotfCreateAlertSucceeded = createAction(
    '[NOTF-ALERT] Create Alert Succeeded',
    props<Alert>()
);

export const NotfCreateAlertFailed = createAction(
    '[NOTF-ALERT] Create Alert Failed',
    props<any>()
);

export const NotfUpdateAlertRequested = createAction(
    '[NOTF-ALERT] Update Alert Requested',
    props<Alert>()
);

export const NotfUpdateAlertSucceeded = createAction(
    '[NOTF-ALERT] Update Alert Succeeded',
    props<Alert>()
);

export const NotfUpdateAlertFailed = createAction(
    '[NOTF-ALERT] Update Alert Failed',
    props<any>()
);

export const NotfAlertsRequested = createAction(
    '[NOTF-ALERT] Alerts Requested'
);

export const NotfAlertsSucceeded = createAction(
    '[NOTF-ALERT] Alerts Succeeded',
    props<{alerts: Alert[]}>()
);

export const NotfAlertsFailed = createAction(
    '[NOTF-ALERT] Alerts Failed'
);

export const NotfAlertsQsWordSet = createAction(
    '[NOTF-ALERT] Alerts QsWord Set',
    props<{ qsWord: string }>()
);

export const NotfAlertsDisableRequested = createAction(
    '[NOTF-ALERT] Alerts Disable Requested',
    props<{alertId: string}>()
);

export const NotfAlertsDisableSucceeded = createAction(
    '[NOTF-ALERT] Alerts Disable Succeeded',
    props<{alertId: string}>()
);

export const NotfAlertsDisableFailed = createAction(
    '[NOTF-ALERT] Alerts Disable Failed'
);

export const NotfAlertsActivateRequested = createAction(
    '[NOTF-ALERT] Alerts Activate Requested',
    props<{alertId: string}>()
);

export const NotfAlertsActivateSucceeded = createAction(
    '[NOTF-ALERT] Alerts Activate Succeeded',
    props<{alertId: string}>()
);

export const NotfAlertsActivateFailed = createAction(
    '[NOTF-ALERT] Alerts Activate Failed'
);

export const NotfAlertsDeleteRequested = createAction(
    '[NOTF-ALERT] Alerts Delete Requested',
    props<{alertId: string}>()
);

export const NotfAlertsDeleteSucceeded = createAction(
    '[NOTF-ALERT] Alerts Delete Succeeded',
    props<{alertId: string}>()
);

export const NotfAlertsDeleteFailed = createAction(
    '[NOTF-ALERT] Alerts Delete Failed'
);